import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DatePickerComponent = ({
  width = 100,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
}) => {
  return (
    <div className="flex justify-center">
      <div className="">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker", "DatePicker"]}>
            <DatePicker
              sx={{
                width,
                height: 60,
              }}
              label="Start Date"
              value={startDate}
              onChange={(newValue) => handleStartDateChange(newValue)}
            />
            <DatePicker
              sx={{
                width,
                height: 60,
              }}
              label="End Date"
              value={endDate}
              onChange={(newValue) => handleEndDateChange(newValue)}
            />
          </DemoContainer>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default DatePickerComponent;
